(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cloudless-page-collection-master"] && !Shopify.designMode) return;
  try {
    class CloudlessCollectionRow extends HTMLElement {
    connectedCallback() {
      const scroller = this.querySelector('[data-collection-row-scroller]');
      if (!scroller || this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      let pointerDown = false;
      let moved = false;
      let startX = 0;
      let startScroll = 0;

      scroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointerDown = true;
        moved = false;
        startX = event.clientX;
        startScroll = scroller.scrollLeft;
      });

      scroller.addEventListener('pointermove', (event) => {
        if (!pointerDown) return;
        const difference = event.clientX - startX;
        if (Math.abs(difference) > 4) {
          moved = true;
          scroller.classList.add('is-dragging');
          scroller.setPointerCapture?.(event.pointerId);
        }
        if (moved) scroller.scrollLeft = startScroll - difference * 1.15;
      });

      const endPointer = () => {
        pointerDown = false;
        scroller.classList.remove('is-dragging');
      };

      scroller.addEventListener('pointerup', endPointer);
      scroller.addEventListener('pointercancel', endPointer);
      scroller.addEventListener('click', (event) => {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }, true);
    }
  }

  if (!customElements.get('cloudless-collection-row')) {
    customElements.define('cloudless-collection-row', CloudlessCollectionRow);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cloudless-page-faq-master"] && !Shopify.designMode) return;
  try {
    class CloudlessFaq extends HTMLElement {
    connectedCallback() {
      if (CloudlessFaq.initialized) return;
      CloudlessFaq.initialized = true;
      this.search = document.querySelector('.cl-faq [data-faq-search]');
      this.searchButton = document.querySelector('.cl-faq [data-faq-search-button]');
      this.filters = [...document.querySelectorAll('.cl-faq [data-faq-filter]')];
      this.items = [...document.querySelectorAll('.cl-faq [data-faq-item]')];
      this.groups = [...document.querySelectorAll('.cl-faq [data-faq-group]')];
      this.empty = document.querySelector('.cl-faq [data-faq-empty]');
      this.activeFilter = 'all';

      this.search?.addEventListener('input', () => this.applyFilters());
      this.searchButton?.addEventListener('click', () => this.applyFilters());
      this.filters.forEach((button) => button.addEventListener('click', () => {
        this.activeFilter = button.dataset.faqFilter || 'all';
        this.applyFilters();
      }));
      this.items.forEach((item) => item.addEventListener('toggle', () => {
        if (!item.open) return;
        this.items.forEach((other) => {
          if (other !== item) other.open = false;
        });
      }));
      this.applyHashFilter();
      window.addEventListener('hashchange', () => this.applyHashFilter());
    }

    applyHashFilter() {
      const key = decodeURIComponent(window.location.hash.slice(1));
      const match = key && this.filters.find((button) => ['topic:', 'product:'].some((prefix) => button.dataset.faqFilter === prefix + key));
      if (match) this.activeFilter = match.dataset.faqFilter;
      this.applyFilters();
    }

    applyFilters() {
      const query = (this.search?.value || '').trim().toLocaleLowerCase();
      let visibleCount = 0;

      this.items.forEach((item) => {
        let matchesFilter = true;
        if (this.activeFilter.startsWith('topic:')) matchesFilter = item.dataset.faqTopic === this.activeFilter.slice(6);
        if (this.activeFilter.startsWith('product:')) matchesFilter = item.dataset.faqProduct === this.activeFilter.slice(8);
        const matchesSearch = !query || item.textContent.toLocaleLowerCase().includes(query);
        item.hidden = !(matchesFilter && matchesSearch);
        if (!item.hidden) visibleCount += 1;
        if (item.hidden) item.open = false;
      });

      this.groups.forEach((group) => {
        group.hidden = ![...group.querySelectorAll('[data-faq-item]')].some((item) => !item.hidden);
      });

      this.filters.forEach((button) => {
        const active = button.dataset.faqFilter === this.activeFilter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (this.empty) this.empty.hidden = visibleCount > 0;
    }
  }

  if (!customElements.get('cloudless-faq')) customElements.define('cloudless-faq', CloudlessFaq);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cloudless-page-reviews-master"] && !Shopify.designMode) return;
  try {
    class CloudlessReviewsSlider extends HTMLElement {
    connectedCallback() {
      const scroller = this.querySelector('[data-reviews-slider-scroller]');
      if (!scroller || this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      let pointerDown = false;
      let moved = false;
      let startX = 0;
      let startScroll = 0;

      scroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointerDown = true;
        moved = false;
        startX = event.clientX;
        startScroll = scroller.scrollLeft;
      });

      scroller.addEventListener('pointermove', (event) => {
        if (!pointerDown) return;
        const difference = event.clientX - startX;
        if (Math.abs(difference) > 4) {
          moved = true;
          scroller.classList.add('is-dragging');
          scroller.setPointerCapture?.(event.pointerId);
        }
        if (moved) scroller.scrollLeft = startScroll - difference * 1.15;
      });

      const endPointer = () => {
        pointerDown = false;
        scroller.classList.remove('is-dragging');
      };

      scroller.addEventListener('pointerup', endPointer);
      scroller.addEventListener('pointercancel', endPointer);
    }
  }

  class CloudlessReviewsPage extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.filters = [...this.querySelectorAll('[data-review-filter]')];
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      this.empty = this.querySelector('[data-review-empty]');
      this.suffix = this.querySelector('[data-filter-suffix]');

      this.filters.forEach((button) => {
        button.addEventListener('click', () => this.applyFilter(button));
      });

      this.querySelectorAll('.clr-video-card__play').forEach((button) => {
        button.addEventListener('click', () => this.toggleVideo(button));
      });

      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-review-card]');
        if (!card || !card.hidden) return;
        const button = this.filters.find((item) => item.dataset.reviewFilter === card.dataset.audience);
        if (button) this.applyFilter(button);
      });

      if (this.filters.length) this.applyFilter(this.filters.find((button) => button.classList.contains('is-active')) || this.filters[0]);
    }

    applyFilter(activeButton) {
      const filter = activeButton.dataset.reviewFilter;
      let visible = 0;

      this.filters.forEach((button) => {
        const active = button === activeButton;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.cards.forEach((card, index) => {
        const show = filter === 'all' || card.dataset.audience === filter;
        card.hidden = !show;
        if (show) {
          card.style.animationDelay = `${Math.min(visible, 8) * 25}ms`;
          visible += 1;
        }
      });

      if (this.empty) this.empty.hidden = visible > 0;
      if (this.suffix) this.suffix.textContent = filter === 'all' ? '' : ` — ${activeButton.dataset.filterLabel}`;
    }

    toggleVideo(button) {
      const card = button.closest('.clr-video-card');
      const video = card?.querySelector('video');
      if (!video) return;

      this.querySelectorAll('.clr-video-card video').forEach((otherVideo) => {
        if (otherVideo === video) return;
        otherVideo.pause();
        otherVideo.closest('.clr-video-card')?.classList.remove('is-playing');
      });

      if (video.paused) {
        video.play();
        card.classList.add('is-playing');
      } else {
        video.pause();
        card.classList.remove('is-playing');
      }

      video.addEventListener('ended', () => card.classList.remove('is-playing'), { once: true });
    }
  }

  if (!customElements.get('cloudless-reviews-slider')) customElements.define('cloudless-reviews-slider', CloudlessReviewsSlider);
  if (!customElements.get('cloudless-reviews-page')) customElements.define('cloudless-reviews-page', CloudlessReviewsPage);
  } catch(e) { console.error(e); }
})();

})();
